'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactKonsulIDOperations = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debounce = require('./utils/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactKonsulIDOperations = exports.ReactKonsulIDOperations = function () {
  function ReactKonsulIDOperations() {
    _classCallCheck(this, ReactKonsulIDOperations);

    this.nodes = {};
  }

  _createClass(ReactKonsulIDOperations, [{
    key: 'setKonsul',
    value: function setKonsul(konsul) {
      this.konsul = konsul;

      konsul.removeAllListeners('shouldRender');

      var debouncer = (0, _debounce2.default)(function () {
        return konsul.render();
      }, 0);
      konsul.debounceRender = function () {
        return debouncer();
      };
    }
  }, {
    key: 'getParent',
    value: function getParent(parent) {
      function _ref2(_id2) {
        if (!(_id2 instanceof Object)) {
          throw new TypeError('Function return value violates contract.\n\nExpected:\nObject\n\nGot:\n' + _inspect(_id2));
        }

        return _id2;
      }

      if (typeof parent === 'string') {
        return _ref2(this.konsul);
      } else {
        return _ref2(parent._node);
      }
    }
  }, {
    key: 'get',
    value: function get(id) {
      if (!(typeof id === 'string')) {
        throw new TypeError('Value of argument "id" violates contract.\n\nExpected:\nstring\n\nGot:\n' + _inspect(id));
      }

      return this.nodes[id];
    }
  }, {
    key: 'add',
    value: function add(id, node) {
      if (!(typeof id === 'number' || typeof id === 'string')) {
        throw new TypeError('Value of argument "id" violates contract.\n\nExpected:\nnumber | string\n\nGot:\n' + _inspect(id));
      }

      if (!(node instanceof Object)) {
        throw new TypeError('Value of argument "node" violates contract.\n\nExpected:\nObject\n\nGot:\n' + _inspect(node));
      }

      this.nodes[id] = node;
    }
  }, {
    key: 'drop',
    value: function drop(id) {
      if (!(typeof id === 'number' || typeof id === 'string')) {
        throw new TypeError('Value of argument "id" violates contract.\n\nExpected:\nnumber | string\n\nGot:\n' + _inspect(id));
      }

      delete this.nodes[id];
    }
  }]);

  return ReactKonsulIDOperations;
}();

exports.default = new ReactKonsulIDOperations();

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : _typeof(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = Object.keys(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : JSON.stringify(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ../lib-react/lib/ReactKonsulIDOperations.js
// module id = 99
// module chunks = 0